import { render, staticRenderFns } from "./CmsPage.vue?vue&type=template&id=34567c54&"
import script from "./CmsPage.vue?vue&type=script&lang=js&"
export * from "./CmsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports